import Header from '../../organisms/Header/Header'
import Logo from '../../../assets/images/tatvacare/tatvacarelogo.svg'
import HeroBg from '../../../assets/images/tatvacare/tatvacarebg.webp'
import AccentAboveLogo from '../../../assets/images/tatvacare/tatvacareheroimage.webp'

const TatvacareHeroSection = () => {
  return (
    <section className="relative w-full overflow-hidden">
      
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img
          src={HeroBg}
          alt=""
          className="h-full w-full object-cover"
        />
      </div>

      {/* Header */}
      <div className="relative z-50">
        <Header textColor="text-black" />
      </div>

      {/* Content */}
      <div className="relative z-20 flex flex-col items-center">

        {/* Logo + Heading */}
        <div className="flex flex-col items-center pt-10 md:pt-24 mb-6">
  <img
    src={Logo}
    alt="Tatvacare Logo"
    className="h-16 w-auto md:h-20 lg:h-24"
  />

  <h1 className="max-w-3xl mt-2  text-center text-2xl font-gilroy-medium leading-tight text-black md:text-4xl lg:text-5xl">
    AI-Powered Clinical Assistant
  </h1>
</div>

       {/* Bottom Full Width Image */}
<div className="relative w-full flex items-end justify-center">

{/* Background Logo */}
<img
  src={Logo}
  alt="Tatvacare Logo"
  className="
   absolute
  md:bottom-15
  lg:bottom-20
  xl:bottom-30
    2xl:bottom-60
    z-10
    w-[90%]
    max-w-8xl
    opacity-10
    object-contain
    pointer-events-none
  "
/>

{/* Front Image */}
<img
  src={AccentAboveLogo}
  alt=""
  className="relative z-20 w-full object-cover"
/>

</div>

      </div>
    </section>
  )
}

export default TatvacareHeroSection